import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "react-router-dom";
import { Col } from "reactstrap";

export const ProductCard = ({ imgSrc, linkTo, text, price, search, onClose, oldprice }) => (
  <Col lg={3} md={4} sm={6} className="mb-1 d-flex align-items-stretch">
    <Link
      onClick={onClose}
      className="w-100 nav-link center hover-opacity rounded d-flex flex-column align-items-center h-100"
      to={{ pathname: linkTo, search: search }}
    >
      <div className="d-flex flex-grow-1 align-items-center justify-content-center w-100">
        {imgSrc && (
          <LazyLoadImage className="center" alt={text} src={imgSrc} width="100%" />
        )}
      </div>
      <p className="pt-1 dark-blue text-center mt-auto"><b>{text}</b></p>
      <p className="dark-blue text-center"><span className="old-price mr-1">{oldprice}</span>{price}</p>
    </Link>
  </Col>
);
